import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { useDashboardGerente } from './hooks/useDashboard.js';
import { KpiCard } from './components/KpiCard.js';
import { AlertCard } from './components/AlertCard.js';
import { TeamRankingTable } from './components/TeamRankingTable.js';
import { DashboardErrorBoundary } from './components/DashboardErrorBoundary.js';
import type { KpiMetric } from '@azoupvendas/shared';

// AIDEV-NOTE: Dashboard do gerente — ranking equipe, pipeline total, alertas
export function DashboardGerente() {
  const { data, isLoading, error } = useDashboardGerente();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Typography color="error" sx={{ p: 2 }}>
        Erro ao carregar dashboard do gerente.
      </Typography>
    );
  }

  const kpis: KpiMetric[] = [
    { label: 'Pipeline Total', value: data.pipelineTotal, unit: 'currency' },
    { label: 'Vendedores na Equipe', value: data.teamRanking.length, unit: 'number' }
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Dashboard Gerencial
      </Typography>

      <Grid container spacing={3}>
        {/* KPI Cards */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {kpis.map((kpi) => (
              <Grid item xs={12} sm={4} key={kpi.label}>
                <DashboardErrorBoundary>
                  <KpiCard metric={kpi} />
                </DashboardErrorBoundary>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Ranking */}
        <Grid item xs={12}>
          <DashboardErrorBoundary fallbackMessage="Erro ao renderizar ranking da equipe">
            <Card>
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  Ranking da Equipe
                </Typography>
                <TeamRankingTable ranking={data.teamRanking} />
              </CardContent>
            </Card>
          </DashboardErrorBoundary>
        </Grid>

        {/* Alertas */}
        <Grid item xs={12}>
          <DashboardErrorBoundary fallbackMessage="Erro ao renderizar alertas">
            <Card>
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  Alertas da Equipe
                </Typography>
                <AlertCard alertas={data.alertas} />
              </CardContent>
            </Card>
          </DashboardErrorBoundary>
        </Grid>
      </Grid>
    </Box>
  );
}
